import { render, staticRenderFns } from "./SupportPackagePicker.vue?vue&type=template&id=10d8b614"
import script from "./SupportPackagePicker.vue?vue&type=script&lang=js"
export * from "./SupportPackagePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports